import { Box, Grid, Typography, useMediaQuery } from "@material-ui/core";
import React, { useState } from "react";
import { logoURL } from "./Constants";
import CopyrightView from "./CopyrightView";
import useStyles from "./Styles";

const FooterView = () => {
  const classes = useStyles();
  const [hovered, setHovered] = useState({
    logo1: false,
    logo2: false,
    logo3: false,
  });
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));

  return (
    <Grid item xs={12}>
      <Box mt={5} px={4}>
        <Grid
          container
          justify="space-between"
          direction={matches ? "row" : "column"}
        >
          <Grid
            item
            container
            md={3}
            xs={12}
            justify="flex-start"
            alignContent="flex-start"
          >
            <Typography variant="subtitle1" gutterBottom>
              Developed By
            </Typography>
            <Grid item container justify="flex-start">
              <Box>
                <img
                  src={logoURL["mekong"]}
                  className={matches ? {} : classes.imgmarxs}
                  alt="asu"
                  width="auto"
                  height="50px"
                />
              </Box>
            </Grid>
          </Grid>
          <Grid
            item
            md={9}
            xs={12}
            direction="column"
            container
            justify="flex-start"
            alignContent="flex-start"
          >
            <Typography variant="subtitle1" gutterBottom>
              In Partnership with
            </Typography>

            <Box>
              <Grid
                container
                justify={matches ? "flex-start" : "center"}
                alignContent="space-around"
                direction={matches ? "row" : "column"}
              >
                <img
                  src={`${logoURL["logo1"]}${
                    hovered["logo1"] ? "_color" : ""
                  }.png`}
                  alt="asu"
                  className={matches ? {} : classes.imgpadxs}
                  width="100px"
                  height="40px"
                  onMouseOver={() => setHovered({ ...hovered, logo1: true })}
                  onMouseLeave={() => setHovered({ ...hovered, logo1: false })}
                />
                <img
                  src={`${logoURL["logo2"]}${
                    hovered["logo2"] ? "_color" : ""
                  }.png`}
                  alt="asu"
                  className={matches ? classes.imgpad : classes.imgpadxs}
                  width="auto"
                  height="40px"
                  onMouseOver={() => setHovered({ ...hovered, logo2: true })}
                  onMouseLeave={() => setHovered({ ...hovered, logo2: false })}
                />
                <img
                  src={`${logoURL["logo3"]}${
                    hovered["logo3"] ? "_color" : ""
                  }.png`}
                  alt="asu"
                  className={matches ? classes.imgpad : classes.imgpadxs}
                  width="auto"
                  height="40px"
                  onMouseOver={() => setHovered({ ...hovered, logo3: true })}
                  onMouseLeave={() => setHovered({ ...hovered, logo3: false })}
                />
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Box>
      {!matches && (
        <Grid container justify="center">
          <CopyrightView />
        </Grid>
      )}
    </Grid>
  );
};

export default FooterView;
